module.exports = __webpack_public_path__ + "img/wx.6e84ddf2.png";